<template>
  <div>
    <v-btn small class="mx-4 float-right" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <v-container v-if="programa && sede">
      <p class="h4 my-1">{{ formatCode(programa) }} {{ programa.nombre_compuesto }}</p>
      <v-divider class="my-0"></v-divider>
      <p class="my-1 purple--text"><strong>Fase:</strong> {{ getFase(programa.fase) }}</p>
      <p class="my-1"><strong>Sede:</strong> {{ sede.nombre }}</p>
      <p class="my-1"><strong>Plataforma Moodle:</strong> {{ plataforma }}</p>
      <p class="my-1"><strong>Categoria Moodle:</strong> {{ categoria }}</p>
      <v-progress-linear
        indeterminate
        height="2"
        background-color="white"
        v-if="loadingcatemoodle || loading_modulos" />
      <v-divider class="my-0"></v-divider>

      <v-btn :disabled="programa.fase > 2" @click="showInscripcion" small rounded color="success" class="ma-1">
        <v-icon>mdi-plus</v-icon> Nueva Inscripción a Programa
      </v-btn>
      <v-btn v-if="programa.inscriptos" to="programains" small rounded color="amber" class="ma-1">
        <v-icon class="mx-1">mdi-playlist-check</v-icon> Ver Inscripciones del Programa</v-btn
      >
      <v-btn
        @click="showAssignPlataform"
        small
        rounded
        :color="programa.plataforma_id ? 'primary' : 'red'"
        class="ma-1">
        Asignar Plataforma <v-icon class="mx-1">mdi-set-split</v-icon></v-btn
      >
      <v-btn
        v-if="programa.plataforma_id"
        :color="programa.course_category_id ? 'primary' : 'red'"
        @click="showAsignarCategoria"
        rounded
        class="ma-1"
        small>
        Asignar Categoria Moodle
      </v-btn>
      <!-- --: {{ programa.plataforma_id }} 
      --: {{ programa.course_category_id }}
      --: {{ xplataforma?xplataforma.id:'.' }} 
      --: {{ parsedModules }}  -->
      <template v-if="modulos.length">
        <v-skeleton-loader :loading="!modulos.length" transition="scale-transition" height="500" type="table">
          <v-data-table :headers="headersModule" :items="modulos" :itemsPerPage="-1" class="elevation-1">
            <template v-slot:[`item.fecha`]="{ item }">
              <span> {{ item.inicio }} {{ item.fin }} </span>
            </template>

            <template v-slot:[`item.modulo.nombre`]="{ item }">
              <p class="mb-0">{{ item.modulo.nombre }}</p>
              <small v-if="item.docente" style="color: grey"> docente: {{ parseDocente(item.docente) }} </small>
            </template>
            <template v-slot:[`item.docente`]="{ item }">
              {{ parseDocente(item.docente) }}
            </template>

            <template v-slot:[`item.course_name`]="{ item }">
              {{ item.course_name }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom v-if="item.inscritos != 0">
                <template #activator="{ on, attrs }">
                  <v-icon class="ma-2" v-bind="attrs" v-on="on" @click="showViewEnrollModule(item)">
                    mdi-table-eye
                  </v-icon>
                </template>
                Ver Inscritos
              </v-tooltip>
              <!-- este boton de inscribir sera solo visisble si el estado del programa_modulo es menor 0 || 1 -->
              <v-tooltip bottom v-if="item.estado < 2 && !disabledBtn(item)">
                <template #activator="{ on, attrs }">
                  <v-icon class="ma-2" v-bind="attrs" v-on="on" color="success" @click="showModuloByEnroll(item)">
                    mdi-book-plus-multiple
                  </v-icon>
                </template>
                Inscribir Estudiantes al Modulo
              </v-tooltip>
              <v-tooltip bottom v-if="programa.course_category_id && programa.plataforma_id && xplataforma">
                <template #activator="{ on, attrs }">
                  <v-icon class="ma-2" v-bind="attrs" v-on="on" color="orange" @click="showAssignCourseID(item)">
                    mdi-alpha-m-box
                  </v-icon>
                </template>
                Asignar Curso Moodle
              </v-tooltip>
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon class="ma-2" v-bind="attrs" v-on="on" color="blue" @click="changeStatusProgramModule(item)">
                    mdi-reload
                  </v-icon>
                </template>
                Cambiar el Estado del Programa-Modulo
              </v-tooltip>
              <v-tooltip bottom v-if="item.estado < 2 && !disabledBtn(item)">
                <template #activator="{ on, attrs }">
                  <v-icon class="ma-2" v-bind="attrs" v-on="on" color="blue" @click="showAssingTeacherMoodle(item)">
                    mdi-teach
                  </v-icon>
                </template>
                Asignar Docente
              </v-tooltip>

              <!-- boton para eliminar la nota de primera instancia, la notas son asignadas desde la app de docentes -->
              <!-- deberian estar visibles si hay fecha de presetacion de primera y segunda instancia -->
              <!-- <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon class="ma-2" v-bind="attrs" v-on="on" color="red" @click="preeiliminarnotainstancia(1, item)"
                    >mdi-text-box-remove</v-icon
                  >
                </template>
                Eliminar notas de primera instancia
              </v-tooltip> -->

              <!-- <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon
                    class="ma-2"
                    v-bind="attrs"
                    v-on="on"
                    color="red lighten-1"
                    @click="preeiliminarnotainstancia(2, item)"
                    >mdi-note-remove</v-icon
                  >
                </template>
                Eliminar notas de segunda instancia
              </v-tooltip> -->
              <!--  -->
              <v-tooltip bottom v-if="item.inscritos != 0">
                <template #activator="{ on, attrs }">
                  <v-icon
                    class="ma-2"
                    v-bind="attrs"
                    v-on="on"
                    color="purple darken-1"
                    @click="vercalificaciones(item)">
                    mdi-file-edit
                  </v-icon>
                </template>
                Calificaciones.
              </v-tooltip>
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon class="ma-0" v-bind="attrs" v-on="on" color="indigo" @click="openEditMod(item)">
                    mdi-pencil
                  </v-icon>
                </template>
                Editar fechas del modulo
              </v-tooltip>
              <v-tooltip bottom v-if="xplataforma && xplataforma.direccion === 'https://campus.upi.edu.pa'">
                <template #activator="{ on, attrs }">
                  <v-icon class="ma-2" v-bind="attrs" v-on="on" color="green darken-1" @click="confirmarModulo(item)">
                    mdi-clipboard-edit
                  </v-icon>
                </template>
                Calificar Módulo
              </v-tooltip>
            </template>
          </v-data-table>
        </v-skeleton-loader>
      </template>
      <!-- start dialog for view all studens enroll by each Module -->
      <view-enroll-ByModule
        ref="refViewEnrollByModule"
        :programa="programa"
        :plataformas="plataformas"
        :inscritosByPrograma="inscritosByPrograma"
        @increase="increaseEnroll" />

      <!-- start dialog for enroll to module -->
      <enroll-module
        ref="refEnrollModule"
        :programa="programa"
        :plataformas="plataformas"
        @increaseEnroll="increaseEnroll" />

      <!-- start dialog for Assign Plataforma of Moodle -->
      <dialog-assign-plataforma ref="assignPlatform" :programa="programa" @reloadGetPlataforma="getPlataforma" />

      <!-- start dialog for AssignCategoria -->
      <dialog-assign-categoria
        ref="assignCategory"
        :programa="programa"
        :plataformas="plataformas"
        @reloadCategoria="loadCategoria" />

      <!-- start dialog for Assign teacher -->
      <dialog-assign-teacher ref="refAssignTeacher" :programa_modulo="oneModulo" :plataformas="plataformas" />

      <!-- start dialog for Moodle -->
      <assign-course-id ref="refAssignCourseID" v-bind.sync="oneModulo" />
    </v-container>
    <div v-else class="text-center mt-4">
      <div style="display: inline-block" class="loader"></div>
    </div>

    <EditMod ref="refEditMod" v-on:onsuccess="oneditMod" />

    <!-- dialog planilla UPI -->
    <v-dialog v-model="dialogPlanillaUpi" max-width="900px">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          Planilla UPI
          <span v-if="moduloSeleccionado" class="ml-2 grey--text text--darken-1">
            — {{ moduloSeleccionado.modulo.nombre }}
          </span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0" style="min-height: 500px">
          <div v-if="loadingPlanilla" class="d-flex flex-column align-center justify-center" style="height: 500px">
            <v-progress-circular indeterminate color="green darken-1" size="48" />
            <p class="mt-3 grey--text">Cargando planilla...</p>
          </div>
          <div v-else-if="planillaBase64" style="height: 500px">
            <iframe :src="planillaDataUrl" width="100%" height="100%" style="border: none" />
          </div>
          <div v-else class="d-flex align-center justify-center red--text" style="height: 500px">
            No se pudo cargar la planilla.
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-3">
          <v-btn text @click="dialogPlanillaUpi = false">Cerrar</v-btn>
          <v-spacer />
          <v-btn color="blue darken-1" outlined :disabled="!planillaBase64" @click="descargarPlanillaPdf">
            <v-icon left>mdi-download</v-icon> Descargar PDF
          </v-btn>
          <v-btn color="green darken-1" dark :loading="loadingCalificacion" :disabled="!planillaBase64" @click="irAModificarCalificacion">
            <v-icon left>mdi-clipboard-edit</v-icon> Ir a Modificar Calificación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import gql from 'graphql-tag';
import xaxios from '@/xaxios';
import { parseProgramaModuloEstado } from '@/components/Utils.js';
import ViewEnrollByModule from './ViewEnrollByModule.vue';
import EnrollModule from './EnrollModule.vue';
import AssignCourseId from './AssignCourseId.vue';
import EditMod from './edit_modulo.vue';
import DialogAssignCategoria from './DialogAssignCategoria.vue';
import DialogAssignPlataforma from './DialogAssignPlataforma.vue';
import DialogAssignTeacher from '@/components/vuetify/DialogAssignTeacher.vue';
import { getheadersrest } from '@/components/Utils';
import { mapState } from 'vuex';

export default {
  components: {
    ViewEnrollByModule,
    EnrollModule,
    AssignCourseId,
    DialogAssignCategoria,
    DialogAssignPlataforma,
    DialogAssignTeacher,
    EditMod,
  },
  data: () => ({
    api_rest: process.env.VUE_APP_API_REST,
    //api_rest_moodle: process.env.UE_APP_API_REST_MOODLE,
    search: '',
    loading_modulos: false,

    headersModule: [
      // { text: 'ID', value: 'id' },
      { text: '#', value: 'numero' },
      { text: 'Nombre de Modulo', value: 'modulo.nombre' },
      // { text: 'Docente', value: 'docente', sortable: false },
      { text: 'Fecha', value: 'fecha', sortable: false, width: '120px' },
      // { text: 'Inicio', value: 'inicio', sortable: false },
      // { text: 'Fecha Fin', value: 'fin', sortable: false },
      { text: 'Estado', value: 'status', sortable: false },
      { text: 'Inscritos', value: 'inscritos', sortable: false },
      { text: 'Opciones', value: 'actions', sortable: false },
      { text: 'Curso Moodle', value: 'course_name' },
    ],
    modulos: [],
    oneModulo: null,
    inscritosByPrograma: [],
    allInscritosByImport: [],
    allInscritosByPostgrado: [],
    sede: null,
    plataforma: 'No Enlazadado con ninguna plataforma Moodle',
    categoria: 'No Asignado a Ninguna Categoria de Moodle',
    plataformas: [],

    datamsg: '',
    xplataforma: {},
    msgerr: '',
    parsedModules: false,
    loadingcatemoodle: false,

    dialogPlanillaUpi: false,
    loadingPlanilla: false,
    loadingCalificacion: false,
    planillaBase64: null,
    planillaNombre: '',
    moduloSeleccionado: null,
  }),
  watch: {
    UNIDAD_NEGOCIO_ID() {
      this.plataformas = [];
      this.getDatosPlataformas();
    },
  },
  computed: {
    ...mapState({
      programa: (state) => state.programa.value,
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
    }),
    planillaDataUrl() {
      if (!this.planillaBase64) return '';
      return `data:application/pdf;base64,${this.planillaBase64}`;
    },
  },
  methods: {
    disabledBtn(c) {
      if (c.course_name == 'Curso No Encontrado') return true;
      else if (c.course_name == 'No enlazado con curso de moodle') return true;
      else if (c.course_name == 'No hay plataforma') return true;
      return false;
    },
    parseDocente(c) {
      if (c) {
        if (!c.seg_apellido) c.seg_apellido = '';
        return `${c.nombres} ${c.pri_apellido} ${c.seg_apellido}`;
      }
      return c;
    },
    openEditMod(item) {
      this.$refs.refEditMod.openDialog(item);
    },
    async confirmarModulo(item) {
      this.moduloSeleccionado = item;
      this.planillaBase64 = null;
      this.planillaNombre = '';
      this.dialogPlanillaUpi = true;
      this.loadingPlanilla = true;
      const url = `${process.env.VUE_APP_URL_API_CALIFICACIONES.replace(/\/$/, '')}/api/reporte-nota/${item.id}/portal/planilla-upi?formato=base64`;
      try {
        const { data } = await xaxios.get(url);
        this.planillaBase64 = data.datos.base64;
        this.planillaNombre = data.datos.nombreArchivo;
      } catch (e) {
        const msg = e?.response?.data?.message ?? 'No se pudo cargar la planilla UPI';
        this.$root.$notify.show(msg, { color: 'red' });
        this.dialogPlanillaUpi = false;
      } finally {
        this.loadingPlanilla = false;
      }
    },
    descargarPlanillaPdf() {
      const link = document.createElement('a');
      link.href = this.planillaDataUrl;
      link.download = this.planillaNombre || 'planilla-upi.pdf';
      link.click();
    },
    async irAModificarCalificacion() {
      this.loadingCalificacion = true;
      const url = `${process.env.VUE_APP_URL_API_CALIFICACIONES.replace(/\/$/, '')}/api/academico/acceso/calificacion-modulo`;
      try {
        const { data } = await xaxios.post(url, { programa_modulo_id: this.moduloSeleccionado.id });
        window.open(data.datos.url, '_blank');
      } catch (e) {
        const msg = e?.response?.data?.message ?? 'No se pudo obtener el acceso a calificaciones';
        this.$root.$notify.show(msg, { color: 'red' });
      } finally {
        this.loadingCalificacion = false;
      }
    },
    countInscritosByModule(programa_modulo) {
      programa_modulo.inscritos = 0;
      [programa_modulo].map(async (modulo) => {
        await xaxios
          .get(`${this.api_rest}/esam/inscripcion/modulo/id/${modulo.id}`)
          .then(({ data: { inscripciones, numero } }) => {
            // window.console.log('dattaaaa:::',inscripciones, numero );
            modulo.numero = numero;
            modulo.inscritos = inscripciones.length;
          })
          .catch(() => (modulo.inscritos = 0));
      });
      return programa_modulo.inscritos;
    },
    async getCourseMoodle2(modulo) {
      // window.console.log('modulo:>',modulo);
      window.console.log('modulo:>', this.xplataforma.direccion);
      if (!this.xplataforma.direccion) {
        modulo.course_name = 'No hay plataforma';
      } else if (!modulo.course_id) {
        modulo.course_name = 'No enlazado con curso de moodle';
      } else {
        const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
          this.xplataforma.id
        }/course/id/${modulo.course_id}`;
        const data = await xaxios
          .get(url)
          .then(({ data }) => data)
          .catch(() => (modulo.course_name = 'Curso No Encontrado'));

        if (data && typeof data == 'object') {
          window.console.log('data:::', data, modulo);
          modulo.course_name = data.fullname;
          // const c = this.programa.programa_modulos.find(x=>x.id==modulo.id)
          // c.course_name = data.fullname;
          // window.console.log('cccc',c);
        }
      }
    },
    getCourseMoodle(programa_modulo) {
      if (!programa_modulo.course_id) return 'No enlazado con curso de moodle';
      this.msgerr = '';
      if (this.xplataforma.id) {
        this.plataformaprograma();
      }
      //window.console.log('URL>>>',this.xplataforma);
      [programa_modulo].forEach((x) => {
        x.status = '';
        x.inscritos = 0;
        x.course_name = '';
      });

      [programa_modulo].map(async (modulo) => {
        const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
          this.xplataforma.id
        }/course/id/${modulo.course_id}`;
        await xaxios
          .get(url)
          .then(({ data }) => (modulo.course_name = data.fullname))
          .catch(() => (modulo.course_name = 'Curso No Encontrado'));
      });
      return programa_modulo.course_name;
    },
    async changeStatusProgramModule(programa_modulo) {
      this.oneModulo = programa_modulo;
      if (await this.$root.$confirm.open('Cambiar Estado Modulo', 'Estas seguro?')) {
        let estado = +programa_modulo.estado == 4 ? 0 : +programa_modulo.estado + 1;
        const sql = gql`mutation{cambiarEstadoProgramaModulo(input:{programa_modulo_id: ${programa_modulo.id}, estado: ${estado}}){ ok,  errors{message} }}`;
        this.$apollo
          .mutate({ mutation: sql })
          .then(({ data: { cambiarEstadoProgramaModulo } }) => {
            if (cambiarEstadoProgramaModulo.ok) {
              this.oneModulo.status = parseProgramaModuloEstado(+estado);
              // // // // window.console.log('fecha.... ', this.oneModulo); // 'Freitag, 24. Juni 2016 01:42'
              this.oneModulo.estado = +estado;
              this.$root.$notify.show(`Estado de Modulo Cambiado Exitosamente`, { color: 'success' });
            } else {
              cambiarEstadoProgramaModulo.errors.forEach((error) =>
                this.$root.$notify.show('ERROR:' + error.message, { color: 'red' }),
              );
            }
          })
          .catch(({ graphQLErrors }) => {
            if (graphQLErrors[0].message.statusCode === 403) {
              this.$root.$notify.show(`Usuario Sin Permiso `, { color: 'red' });
            } else {
              this.$root.$notify.show(`${JSON.stringify(graphQLErrors[0].message)}`, { color: 'red' });
            }
          });
      }
    },
    showInscripcion() {
      let date = new Date(this.programa.fecha_matriculacion);
      let now = new Date();
      if (date > now) {
        let fs = this.programa.fecha_matriculacion.split('-');
        this.$root.$notify.show(`La fecha de matriculacion inicia: ${fs[2]}/${fs[1]}/${fs[0]}`, {
          color: 'red',
          x: 'right',
        });
        return;
      }
      if (this.programa.fase == 0) {
        this.$root.$notify.show('Programa no aprobado', { color: 'red' });
      } else if (this.programa.fase > 1) {
        this.$root.$notify.show('Este programa ya no esta en Fase de Inscripciones', { color: 'warning' });
      } else {
        window.sessionStorage.setItem('xprograma', JSON.stringify(this.programa));
        window.sessionStorage.setItem('route_ins', 'programas');
        window.sessionStorage.removeItem('xpreinscrito');
        window.sessionStorage.removeItem('xinscritotoplan'); //
        sessionStorage.removeItem('xpreinscrito');
        sessionStorage.removeItem('xinscritotoplan');

        this.$router.push({ name: 'inscripcionrest' });
      }
    },

    async getInscriptosByPrograma() {
      const sql = gql`query{ getPrograma(id:${this.programa.id}){arte,sede{nombre}
        ,inscripciones{certificado_id,id,estado_ins,fecha_registro,asesor{id},preinscripcion
            ,estudiante{id,email,num_doc,telefono1,usuario_moodle,clave_moodle,nombres,pri_apellido,seg_apellido,departamento{extension},estado}
            ,programa{id,nombre_compuesto,fase,estado,version,grupo,fecha_inicio,fecha_fin}
          }}}`;
      await this.$apollo
        .query({ query: sql })
        .then(({ data: { getPrograma } }) => {
          this.sede = getPrograma.sede;
          getPrograma.inscripciones.forEach((e) => {
            if (!e.estudiante) e.estudiante = {};
          });
          this.inscritosByPrograma = getPrograma.inscripciones;
          this.inscritosByPrograma.sort(function ({ estudiante }, { estudiante: { pri_apellido } }) {
            return `${estudiante.pri_apellido}`.localeCompare(pri_apellido);
          });
        })
        .catch((e) => {
          window.console.log(e);
          this.$root.$notify.show('ERROR: getPrograma No hay datos del programa', { color: 'orange' });
        });
    },
    getFase(fase) {
      //'inscripciones, en desarrollo, en tramite, cerrado',
      if (fase == 0) return 'NO APROBADO';
      else if (fase == 1) return 'INSCRIPCIONES';
      else if (fase == 2) return 'EN DESARROLLO';
      else if (fase == 3) return 'CONCLUIDO';
      else if (fase == 4) return 'ELABORACION TRABAJOS FINALES';
      else if (fase == 5) return 'RECEPCION DE REQUISITOS DE TITULACION';
      else if (fase == 6) return 'ARMADO CARPETAS';
      else if (fase == 7) return 'PAGO ARANCELES';
      else if (fase == 8) return 'PROCESO TITULACION';
      else if (fase == 9) return 'CERTIFICADOS ENTREGADOS';
      else if (fase == 10) return 'NO EJECUTADO';
      else return 'DESCONOCIDO: ' + fase;
    },

    getPlataforma() {
      if (!this.programa.plataforma_id) return this.plataforma;
      this.$apollo
        .query({ query: gql`query{ getPlataforma(id:${this.programa.plataforma_id}){ id nombre direccion estado }}` })
        .then(({ data: { getPlataforma } }) => {
          this.xplataforma = getPlataforma;
          if (getPlataforma) {
            this.plataforma = `${getPlataforma.nombre} - ${getPlataforma.direccion}`;
            this.loadCategoria();
          }
        })
        .catch(() =>
          this.$root.$notify.show('ERROR: getPlataforma nose cargo la Plataforma Moodle', { color: 'orange' }),
        );
    },
    loadCategoria() {
      if (!this.programa.course_category_id) return this.plataforma;
      this.msgerr = '';
      /* if (!this.xplataforma.id) {
          this.plataformaprograma();
        } */
      if (this.xplataforma.id && !this.parsedModules) {
        this.plataformaprograma();
      }
      if (!this.xplataforma.direccion) {
        return;
      }
      this.loadingcatemoodle = true;
      let url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
        this.xplataforma.id
      }/category/id/${this.programa.course_category_id}`;
      //window.console.log( url,this.plataformas );
      xaxios
        .get(url)
        .then(({ data }) => {
          // window.console.log('cateeee', this.programa,this.xplataforma,data);
          this.categoria = `${data.name} (ID:${data.id})`;
        })
        .catch(() => {
          this.$root.$notify.show('ERROR: getCategoria nose cargo la Plataforma Moodle', { color: 'orange' });
        })
        .finally(() => {
          this.loadingcatemoodle = false;
        });
    },

    showModuloByEnroll(programa_modulo) {
      this.oneModulo = programa_modulo;
      this.$refs.refEnrollModule.showThisView(this.modulos, programa_modulo, this.inscritosByPrograma);
    },
    showAssignPlataform() {
      this.$refs.assignPlatform.dialog = true;
      this.$refs.assignPlatform.setPlataforma(this.xplataforma);
    },
    showAsignarCategoria() {
      this.$refs.assignCategory.dialog = true;
    },
    showAssignCourseID(programa_modulo) {
      this.oneModulo = programa_modulo;
      this.$refs.refAssignCourseID.showThisView(programa_modulo, this.programa);
    },
    showAssingTeacherMoodle(programa_modulo) {
      this.oneModulo = programa_modulo;
      this.$refs.refAssignTeacher.showThisView(programa_modulo);
    },
    showViewEnrollModule(programa_modulo) {
      this.oneModulo = programa_modulo;
      window.console.log('ver inscritos modulo: ', programa_modulo);
      this.$refs.refViewEnrollByModule.showThisView(programa_modulo, this.xplataforma);
    },
    vercalificaciones(programa_modulo) {
      // window.console.log(programa_modulo);
      let idpostgrado = this.programa.postgrado.id;
      let courseid = programa_modulo.course_id;
      let programa_modulo_id = programa_modulo.id;
      this.$router.push(
        `/calificaciones?idmodulo=${programa_modulo.id}&idpostgrado=${idpostgrado}&course_id=${courseid}&programa_modulo_id=${programa_modulo_id}&plataforma_id=${this.xplataforma.id}&plataforma=${this.xplataforma.direccion}`,
      );
    },
    preeiliminarnotainstancia(numeroinstancia, item) {
      // window.console.log(item);
      let text = numeroinstancia == 1 ? 'PRIMERA INSTANCIA' : 'RECUPERATORIO';
      var vue = this;
      var opt = {
        verification: 'eliminar',
        verificationHelp: `Escriba "[+:verification]" para eliminar notas de ${text}.`,
        okText: 'Eliminar notas',
        cancelText: 'cancelar',
        backdropClose: false,
        animation: 'bounce',
        loader: true,
        type: 'hard',
      };
      var message = {
        title: 'Confirmar eliminacion',
        body: `<br> <b>NOTA:</b> Esta opcion permite al docente volver a registrar las notas de <b>${text}</b> en caso de haber cometido algun error, tomar en cuenta que las notas ya presentadas seran eliminadas y reemplazadas por las nuevas notas.<br>`,
      };
      this.$dialog
        .confirm(message, opt)
        .then(function (dialog) {
          vue.eliminarnotainstancia(numeroinstancia, item, dialog);
        })
        .catch(function () {});
    },
    eliminarnotainstancia(numeroinstancia, item, dialog) {
      //window.console.log( numeroinstancia,item,process.env.VUE_APP_API_REST );
      let instancia = numeroinstancia == 1 ? 'primera' : 'segunda';
      const vue = this;
      let myHeaders = getheadersrest();

      var requestOptions = {
        method: 'DELETE',
        redirect: 'follow',
        headers: myHeaders,
      };
      let urlinstancia =
        process.env.VUE_APP_API_REST + `/esam/nota/programa/modulo/id/${item.id}/${instancia}/instancia`;
      // window.console.log( 'delete instancia:',urlinstancia );
      fetch(urlinstancia, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          dialog.close();
          if (result.error) vue.notificaciondeleteinstancia(result.error);
          else if (result.result) vue.notificaciondeleteinstancia(result.result);
          else vue.notificaciondeleteinstancia('error: ' + result);
          // window.console.log(result);
        })
        .catch(() => {
          // window.console.log('error', error);
          dialog.close();
          vue.notificaciondeleteinstancia('No se pudo realizar la eliminacion de notas.');
        });
    },
    notificaciondeleteinstancia(txt) {
      this.$dialog
        .alert(txt)
        .then(function (dialog) {
          dialog.close();
        })
        .catch(function () {});
    },
    getDatosInscripcion(id) {
      // this method get getInscripcion, this is only test for verify student
      this.$apollo
        .query({
          query: gql`query { getInscripcion(id: ${id}) { id idprograma idestudiante estado_ins observaciones idasesor fecha_registro
            registrado_por monto_matricula monto_colegiatura monto_certificacion cuotas tipopago certificado_id puede_cambiar 
            estudiante { id num_doc nombres pri_apellido seg_apellido }
            programa{ id idpostgrado nombre_compuesto } }}`,
        })
        .then(({ data: { getInscripcion } }) => {
          // window.console.log(`getInscripcion: ${id}`, getInscripcion);
          getInscripcion;
        })
        .catch((err) => this.$root.$notify.show(`ERROR: getInscripcion ${err}`));
    },
    async parseModulos() {
      this.modulos = [];
      const vue = this;
      this.loading_modulos = true;
      this.programa.programa_modulos.sort((a, b) => a.id - b.id);
      for (let i = 0; i < this.programa.programa_modulos.length; i++) {
        let modulo = this.programa.programa_modulos[i];
        modulo.status = '';
        modulo.inscritos = 0;
        modulo.course_name = '';

        modulo.status = parseProgramaModuloEstado(+modulo.estado);
        modulo.inscritos = vue.countInscritosByModule(modulo);
        // modulo.course_name = vue.getCourseMoodle(modulo);
        await vue.getCourseMoodle2(modulo);
      }
      /*this.programa.programa_modulos.forEach(async (modulo) => {
          // window.console.log('???????',modulo);
          modulo.status = '';
          modulo.inscritos = 0;
          modulo.course_name = '';

          modulo.status = parseProgramaModuloEstado(+modulo.estado);
          modulo.inscritos = vue.countInscritosByModule(modulo);
          // modulo.course_name = vue.getCourseMoodle(modulo);
          await vue.getCourseMoodle2(modulo)
          // return modulo;
        });*/

      this.modulos = this.programa.programa_modulos;
      this.loading_modulos = false;
    },
    increaseEnroll(modulo) {
      this.oneModulo = modulo;
      this.modulos.push({ id: -1 });
      this.modulos.pop();
    },
    formatCode(program) {
      return `${program.nombre_compuesto.slice(0, 1)}-${program.id}`.toUpperCase();
    },

    getDatosPlataformas() {
      this.$apollo
        .query({
          query: gql`query { getPlataformas(estado: true,unidad_negocio_id: ${this.UNIDAD_NEGOCIO_ID}) { id nombre direccion unidad_negocio_id estado }}`,
        })
        .then(({ data: { getPlataformas } }) => {
          this.plataformas = getPlataformas;
          if (this.xplataforma != undefined && this.xplataforma.nombre) {
            this.plataformaprograma();
            this.loadCategoria();
          }
          //window.console.log('Plataformas: ',this.plataformas,this.programa, this.xplataforma)
        })
        .catch((err) => {
          this.$root.$notify.show(`ERROR: getPlataformas(ViewProgramaModules) ${err}`);
        });
    },

    plataformaprograma() {
      // window.console.log(this.plataformas, this.programa);
      if (this.plataformas.length == 0 || !this.programa) return;
      if (!this.programa.plataforma_id) {
        window.console.log('No asignado plataforma.', this.programa);
        return;
      }
      let plataforma_id = this.programa.plataforma_id;
      this.xplataforma = this.plataformas.find((x) => x.id == plataforma_id);
      window.console.log('plataformaaa:::', this.xplataforma);
      this.datamsg = `<b>Plataforma</b>: ${this.xplataforma.nombre}`;
      if (!this.parsedModules) {
        this.parsedModules = true;
        this.parseModulos();
      }
    },
    parseFecha(d) {
      if (!d) return d;
      const fs = (d + '').split('/');
      return `${fs[2]}-${fs[1]}-${fs[0]}`;
    },
    oneditMod(mod) {
      window.console.log('mod', mod, this.modulos);
      const m = this.modulos.find((x) => x.id == mod.id);
      if (m) {
        m.inicio = this.parseFecha(mod.fecha_inicio);
        m.fin = this.parseFecha(mod.fecha_fin);
      }
    },
    iniciar() {
      this.parsedModules = false;
      this.getDatosPlataformas();
      this.parseModulos();
      this.getInscriptosByPrograma();
      this.getPlataforma();
      this.loadCategoria();
    },
  },
  mounted() {
    this.iniciar();
  },
  // ==============join two objes array ======
  // const a = [
  //   {id: 4, name: 'Greg'},
  //   {id: 1, name: 'David'},
  //   {id: 2, name: 'John'},
  //   {id: 3, name: 'Matt'},
  // ];
  // ==============
  // const a = [{id: 1}, {id: 2}];
  // const b = [{id: 3}, {id: 4}];
  // const result = [...a, ...b];
  // console.log(result);
  // // outputs: [{id: 1}, {id: 2}, {id: 3}, {id: 4}]

  // const b = [
  //   {id: 5, name: 'Mathew', position: '1'},
  //   {id: 6, name: 'Gracia', position: '2'},
  //   {id: 2, name: 'John', position: '2'},
  //   {id: 3, name: 'Matt', position: '2'},
  // ];
  // const r = a.filter(({ id: idv }) => b.every(({ id: idc }) => idv !== idc));
  // const newArr = b.concat(r).map((v) => v.position ? v : { ...v, position: null });

  // console.log(JSON.stringify(newArr));

  // ========Removing item (ECMAScript 6 code)========
  // let value = 3
  // let arr = [1, 2, 3, 4, 5, 3]
  // arr = arr.filter(item => item !== value)
  // console.log(arr) // output: // [ 1, 2, 4, 5 ]

  // ========Removing multiple items (ECMAScript 7 code)========
  // An additional advantage of this method is that you can remove multiple items
  // let forDeletion = [2, 3, 5]
  // let arr = [1, 2, 3, 4, 5, 3]

  // arr = arr.filter(item => !forDeletion.includes(item))
  // // !!! Read below about array.includes(...) support !!!
  // console.log(arr)   // output // [ 1, 4 ]
  // ========Removing a objects from array ========
  //  deleteRow(item:any){
  //     let index=this.items.findIndex(it=>it.email===item.email)
  //       this.items.splice(index,1);
  //   }

  // ========correcciones=======================
  // mostrar en texto rojo y claro q al momento de inscribir los estudiantes solo seran creados en el sistema y no el moodle
  // si  existe plataforma, inscribar a moodle sino mostrar abvertencia y solo se inscribira en el sistema
  // only buttom for create username in moodle with select
  // mostrar botones cuando se asigna un curso_id
  // al momento de inscribir subir el contador de la vista general
  // ===============abreviaturas
  // v-vind:value="'aaa'"   => only :value="'aaa'"
  // <a v-on:click="doSomething">   => only <a @click="doSomething">
  // <template v-slot:item.full_name="{ item }"> <template #[`item.full_name`]="{ item }">
  // <template v-slot:activator="{ on, attrs }"> <template #activator="{ on, attrs }">

  // ========Error===========
  // .catch((error) => {
  //   if (error.response) {
  //     window.console.log(error.response.data);
  //     window.console.log(error.response.status);
  //     window.console.log(error.response.headers);
  //   }
  // });
};
</script>
